import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/lightPoint.png';
import _imports_1 from '@/assets/img/index/codeFix.svg';
import _imports_2 from '@/assets/img/index/dateSeries.svg';
import _imports_3 from '@/assets/img/index/loopPocExp.svg';
import _imports_4 from '@/assets/img/index/openCollaboration.svg';
const _withScopeId = n => (_pushScopeId("data-v-33bbaa31"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "back-agent"
};
const _hoisted_2 = {
  alt: ""
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-page"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "专注于两大领域的智能服务")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "程序语言"), /*#__PURE__*/_createElementVNode("span", null, "软件开发")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, " 辅助深入理解与应对各种安全编程挑战，提升代码质量 ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "开发者"), /*#__PURE__*/_createElementVNode("span", null, "安全研究者")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "促进开发和安全团队之间的协作")])])], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "con-detail"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 代码分析与修复能力 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 丰富的多场景数据集 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 漏洞分析与探索（PoC、EXP） ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_4,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 开放的协作与集成能力 ")])], -1));
import agentCom from './agentCom.vue';
import { ref } from 'vue';
export default {
  __name: 'codeAgentCom',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'code-agent active' : 'code-agent')
      }, [_createVNode(agentCom, {
        "flex-revert": true,
        showBotton: true,
        title: '代码安全类智能体',
        pageUrl: '/codeSafety.html'
      }, {
        left: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [[_directive_lazy, require('@/assets/img/index/codeAgentInst.svg')]])])]),
        right: _withCtx(() => [_hoisted_3]),
        bottom: _withCtx(() => [_hoisted_4]),
        _: 1
      })], 2);
    };
  }
};